import { useState, useCallback } from 'react';

const useToast = () => {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, type = 'info', size = 'normal', duration = 4000) => {
    const id = Date.now() + Math.random();
    const newToast = {
      id,
      message,
      type,
      size,
      duration
    };

    setToasts(prev => [...prev, newToast]);

    // Auto-remove toast after duration + animation time
    const removeDelay = duration + 1500;
    setTimeout(() => {
      setToasts(prev => prev.filter(toast => toast.id !== id));
    }, removeDelay);

    return id;
  }, []);

  const removeToast = useCallback((id) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  }, []);

  const success = useCallback((message, size = 'normal', duration) => 
    showToast(message, 'success', size, duration), [showToast]);
  
  const error = useCallback((message, size = 'normal', duration) => 
    showToast(message, 'error', size, duration), [showToast]);
  
  const warning = useCallback((message, size = 'normal', duration) => 
    showToast(message, 'warning', size, duration), [showToast]);
  
  const info = useCallback((message, size = 'normal', duration) => 
    showToast(message, 'info', size, duration), [showToast]);

  return {
    toasts,
    showToast,
    removeToast,
    success,
    error,
    warning,
    info
  };
};

export default useToast;